<!-- start footer -->
<footer class="footer-seo-agency footer-light">
    <div class="footer-top padding-five-tb lg-padding-seven-tb md-padding-50px-tb">
        <div class="container">
            <div class="row mb-5">
                <div class="col-md-2"><img style="max-height: 50px;" width="100%" src="/assets/images/dhl.png"></div>
                <div class="col-md-2"><img style="max-height: 50px;" width="100%" src="/assets/images/cp.png"></div>
                <div class="col-md-2"><img style="max-height: 50px;" width="100%" src="/assets/images/fedex.jpg"></div>
                <div class="col-md-2"><img style="max-height: 50px;" width="100%" src="/assets/images/2shipit.png"></div>
                <div class="col-md-2"><img style="max-height: 50px;" width="100%" src="/assets/images/toll.jpg"></div>
                <div class="col-md-1"><img style="max-height: 50px;" width="100%" src="/assets/images/quickexpress.png"></div>
                <div class="col-md-1"><img style="max-height: 50px;" width="100%" src="/assets/images/aramex.png"></div>
             
            </div>
            <div class="row">
                <!-- start footer column -->
                <div class="col-12 col-md-6 col-sm-6 sm-margin-40px-bottom xs-margin-25px-bottom">
                    <span class="alt-font font-weight-500 d-block text-medium-slate-blue margin-15px-bottom xs-margin-10px-bottom">Your trusted delivery partner</span>
                    <p>ParcelPlus, previously known as MNPFreight has been operating in Alexandria Sydney since 2003. We have been helping small to medium size businesses with their logistics domestically and Internationally.</p>
                    <!-- <ul>
                        <li><a href="about-us.html">About company</a></li>
                        <li><a href="our-services.html">Our services</a></li>
                        <li><a href="our-team.html">Job opportunities</a></li>
                        <li><a href="contact-us-classic.html">Contact us</a></li>
                    </ul> -->
                </div>
                <!-- end footer column -->
                <!-- start footer column -->
               
                <!-- end footer column -->
                <!-- start footer column -->
                <div class="col-12 col-md-3 col-sm-6 xs-margin-25px-bottom">
                    <span class="alt-font font-weight-500 d-block text-medium-slate-blue margin-15px-bottom xs-margin-10px-bottom">Contact Us</span>
                    <ul>                           
                        <li>75/85 O'Riordan St, Alexandria NSW 2015</li>
                        <li>Australia</li>
                        <li>(02) 8338 8763</li>
                        <li>info@parcelplusfrontend.com.au</li>
                    </ul>
                </div>
                <!-- end footer column -->
            </div>
        </div>
    </div>
    <div class="footer-bottom padding-40px-tb border-top border-color-medium-gray">
        <div class="container"> 
            <div class="row align-items-center">
                <div class="col-12 col-md-3 text-center text-md-start sm-margin-20px-bottom">
                    <a href="/" class="footer-logo"><img src="assets/images/logo-gradient-magenta-orange.png" data-at2x="assets/images/logo-gradient-magenta-orange@2x.png" alt=""></a>
                </div>
                <div class="col-12 col-md-6 text-center last-paragraph-no-margin sm-margin-20px-bottom">
                    <p>&copy; 2023 <a href="https://parcelplusfrontend.com.au/" target="_blank" class="text-medium-slate-blue text-decoration-line-bottom font-weight-500">ParcelPlus</a></p>
                </div>
             
            </div>
        </div>
    </div>
</footer>
<!-- end footer -->